import {
  Instant as Instant,
  Clock as Clock,
} from '@js-joda/core';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  _Duration___get_inWholeSeconds__impl__hpy7b32mb043ng683qx as _Duration___get_inWholeSeconds__impl__hpy7b3,
  _Duration___get_nanosecondsComponent__impl__nh19kq3qe435uvlnjyf as _Duration___get_nanosecondsComponent__impl__nh19kq,
  Duration__isPositive_impl_tvkkt23mvdjuzm9oa9z as Duration__isPositive_impl_tvkkt2,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForObject(System, 'System');
initMetadataForCompanion(Companion);
initMetadataForClass(Instant_0, 'Instant');
//endregion
function System() {
}
protoOf(System).i7 = function () {
  return Companion_getInstance().i7();
};
var System_instance;
function System_getInstance() {
  return System_instance;
}
function Companion() {
  Companion_instance = this;
  var tmp = this;
  // Inline function 'kotlinx.datetime.jsTry' call
  // Inline function 'kotlinx.datetime.Companion.DISTANT_PAST.<anonymous>' call
  var tmp$ret$1 = Instant.ofEpochSecond((new Long(-931914497, -750)).u1(), 999999999);
  tmp.j7_1 = new Instant_0(tmp$ret$1);
  var tmp_0 = this;
  // Inline function 'kotlinx.datetime.jsTry' call
  // Inline function 'kotlinx.datetime.Companion.DISTANT_FUTURE.<anonymous>' call
  var tmp$ret$3 = Instant.ofEpochSecond((new Long(1151527680, 720)).u1(), 0);
  tmp_0.k7_1 = new Instant_0(tmp$ret$3);
  this.l7_1 = new Instant_0(Instant.MIN);
  this.m7_1 = new Instant_0(Instant.MAX);
}
protoOf(Companion).i7 = function () {
  return new Instant_0(Clock.systemUTC().instant());
};
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function Instant_0(value) {
  Companion_getInstance();
  this.n7_1 = value;
}
protoOf(Instant_0).o7 = function (duration) {
  // Inline function 'kotlin.time.Duration.toComponents' call
  var tmp1 = _Duration___get_inWholeSeconds__impl__hpy7b3(duration);
  var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(duration);
  var tmp;
  try {
    tmp = new Instant_0(this.p7(tmp1.u1(), nanoseconds));
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      if (!isJodaDateTimeException(e))
        throw e;
      tmp_0 = Duration__isPositive_impl_tvkkt2(duration) ? Companion_getInstance().m7_1 : Companion_getInstance().l7_1;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(Instant_0).p7 = function (seconds, nanos) {
  var newSeconds = this.n7_1.epochSecond() + seconds;
  var newNanos = this.n7_1.nano() + nanos;
  // Inline function 'kotlinx.datetime.jsTry' call
  // Inline function 'kotlinx.datetime.Instant.plusFix.<anonymous>' call
  return Instant.ofEpochSecond(newSeconds, numberToInt(newNanos));
};
protoOf(Instant_0).q7 = function (other) {
  return this.n7_1.compareTo(other.n7_1);
};
protoOf(Instant_0).g1 = function (other) {
  return this.q7(other instanceof Instant_0 ? other : THROW_CCE());
};
protoOf(Instant_0).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof Instant_0) {
      tmp_0 = this.n7_1 === other.n7_1 || this.n7_1.equals(other.n7_1);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(Instant_0).hashCode = function () {
  return this.n7_1.hashCode();
};
protoOf(Instant_0).toString = function () {
  return this.n7_1.toString();
};
function isJodaDateTimeException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'DateTimeException');
}
function hasJsExceptionName(_this__u8e3s4, name) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.name == name;
}
//region block: init
System_instance = new System();
//endregion
//region block: exports
export {
  System_instance as System_instance1733vxoer52pz,
};
//endregion

//# sourceMappingURL=Kotlin-DateTime-library-kotlinx-datetime.mjs.map
